import { Controller } from "stimulus";

export default class PromotionOrderController extends Controller {
  static values = { url: String };
  static targets = ["position"];

  connect() {
    this.element.addEventListener("dragstart", this.dragStart.bind(this));
    this.element.addEventListener("dragover", this.dragOver.bind(this));
    this.element.addEventListener("drop", this.drop.bind(this));
    this.element.addEventListener("dragend", this.dragEnd.bind(this));
  }

  dragStart(event) {
    const row = event.target.closest("[draggable]");
    this.draggedRow = row;
    event.dataTransfer.setData("text/plain", row.id);
    setTimeout(() => row.classList.add("hidden"), 0);
  }

  dragEnd() {
    if (this.draggedRow) {
      this.draggedRow.classList.remove("hidden");
      this.draggedRow = null;
    }
    this.removeIndicators();
    this.currentDragTarget = null;
  }

  dragOver(event) {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";

    const target = event.target.closest("[draggable]");
    if (target && target !== this.currentDragTarget) {
      this.removeIndicators();
      this.addIndicator(target);
      this.currentDragTarget = target;
    }
  }

  drop(event) {
    event.preventDefault();

    const draggedId = event.dataTransfer.getData("text/plain");
    const dragged = document.getElementById(draggedId);
    const target = this.currentDragTarget;

    dragged.classList.remove("hidden");
    this.removeIndicators();

    if (target && target !== dragged) {
      target.insertAdjacentElement("beforebegin", dragged);
    }

    this.renumber();
    this.persist();
  }

  renumber() {
    this.positionTargets.forEach((el, i) => el.textContent = i + 1);
  }

  persist() {
    const ids = Array.from(this.element.querySelectorAll("[draggable]"))
      .map((el) => el.dataset.promotionId);
    const body = ids.map((id) => `ids[]=${id}`).join("&");

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content,
      },
      body,
    });
  }

  removeIndicators() {
    this.element.querySelectorAll("[data-drag-indicator]").forEach((el) => el.remove());
  }

  addIndicator(target) {
    const indicator = document.createElement("tr");
    indicator.dataset.dragIndicator = true;
    indicator.innerHTML = `<td colspan="99" class="h-1 bg-indigo-300"></td>`;
    target.insertAdjacentElement("beforebegin", indicator);
  }
}
